import styled from '@emotion/styled'

const AddContact = ({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      Add contact
    </div>
  )
}

export default styled(AddContact)`
  color: ${props => props.theme.color.monochrome.superDark};
  cursor: pointer;
  /* Prevent showing caret beside the add contact text */
  /* because users may think the field is focused and start typing, then trigger shortcuts */
  user-select: none;
`
